import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { DELETE, PATCH, POST } from 'utils/httpMethods';
import { TextField } from 'components/form/field';

// Détail d'une version du DCA : renommage (champ redux-form) et activation (action immédiate).
const VersionPanel = ({ type, name, label, version, isActive, onChanged, setMessage }) => {
    const updateDcaFields = async () => {
        await PATCH(`/api/dca/${type}/${version.id}/updateDcaFields`, { body: { label } });
        setMessage('Libellé enregistré.');
        await onChanged();
    };

    const activateDca = async () => {
        try {
            await POST(`/api/dca/${type}/${version.id}/activateDca`);
            setMessage('Version activée.');
            await onChanged();
        } catch (error) {
            const data = await error.response.json();
            setMessage(data.error || 'L’activation a échoué.');
        }
    };

    const deleteDca = async () => {
        if (isActive) {
            setMessage('Impossible de supprimer la version active. Veuillez d’abord activer une autre version.');

            return;
        }

        try {
            await DELETE(`/api/dca/${type}/${version.id}/${version.originalName}/deleteDca`);
            setMessage('Version supprimée.');
            await onChanged();
        } catch (error) {
            const data = await error.response.json();
            setMessage(data.error || 'La suppression a échoué.');
        }
    };

    return (
        <div className="dca-settings__version">
            <div className="dca-settings__field-row">
                <TextField
                    name={`${name}.label`}
                    className="dca-settings__label-field"
                />
                <button
                    type="button"
                    className="dca-settings__label-btn"
                    onClick={updateDcaFields}
                >
                    Enregistrer le libellé
                </button>
            </div>
            <div className="dca-settings__button-row">
                <button
                    type="button"
                    className="theseis-btn"
                    onClick={deleteDca}
                >
                    Supprimer
                </button>
                {!isActive && (
                    <button type="button" className="theseis-btn" onClick={activateDca}>Activer cette version</button>
                )}
            </div>

        </div>
    );
};

VersionPanel.propTypes = {
    type: PropTypes.oneOf(['lifeInsurance', 'per']).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    version: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.string.isRequired,
        originalName: PropTypes.string.isRequired,
    }),
    isActive: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
    setMessage: PropTypes.func.isRequired,
};

VersionPanel.defaultProps = {
    label: '',
};

export default connect((state, { form, name }) => ({
    label: formValueSelector(form)(state, `${name}.label`),
}))(VersionPanel);
